import React from "react";
import { Link } from "react-router-dom";
import { CalendarDays, ChevronRight, ArrowRight } from "lucide-react";
import Layout from "../components/Layout";
import Seo from "../seo/Seo";
import { newsListGraph } from "../seo/jsonld";
import { news } from "../mock";

const TITLE = "Aktuality z kampane | Ján Kuráň Ružomberok 2026";
const DESC =
  "Najnovšie novinky, pozvánky a fotky z kampane Jána Kuráňa, kandidáta na primátora Ružomberka 2026.";

const NewsPage = () => (
  <Layout>
    <Seo
      title={TITLE}
      description={DESC}
      path="/aktuality"
      jsonLd={newsListGraph({ path: "/aktuality", title: TITLE, description: DESC }, news)}
    />
    <section className="bg-campaign-blue px-4 sm:px-6 py-12 sm:py-16">
      <div className="max-w-5xl mx-auto">
        <nav aria-label="Omrvinková navigácia" className="text-campaign-cream/70 text-sm font-semibold mb-6 flex items-center gap-1">
          <Link to="/" className="hover:text-campaign-yellow">Domov</Link>
          <ChevronRight size={14} />
          <span className="text-campaign-yellow">Aktuality</span>
        </nav>
        <h1 className="font-display text-4xl sm:text-6xl text-campaign-cream leading-none uppercase">
          Aktuality z kampane
        </h1>
        <p className="mt-4 text-campaign-cream/85 max-w-2xl">{DESC}</p>
      </div>
    </section>

    <section className="bg-campaign-cream px-4 sm:px-6 py-12 sm:py-16">
      <div className="max-w-5xl mx-auto grid sm:grid-cols-2 gap-8">
        {news.map((post) => (
          <article key={post.slug} className="border-4 border-campaign-ink shadow-brutal hover-lift flex flex-col">
            <Link to={`/aktuality/${post.slug}`}>
              <img src={post.image} alt={post.title} loading="lazy" className="w-full h-56 object-cover border-b-4 border-campaign-ink" />
            </Link>
            <div className="p-6 flex flex-col flex-1">
              <span className="inline-flex items-center gap-1.5 text-campaign-ink/60 text-xs font-bold uppercase mb-2">
                <CalendarDays size={14} /> {post.dateLabel}
              </span>
              <h2 className="font-display text-xl text-campaign-ink uppercase leading-tight mb-2">
                <Link to={`/aktuality/${post.slug}`} className="hover:text-campaign-blue">{post.title}</Link>
              </h2>
              <p className="text-campaign-ink/80 flex-1">{post.excerpt}</p>
              <Link to={`/aktuality/${post.slug}`} className="mt-4 inline-flex items-center gap-1 font-semibold text-campaign-blue hover:underline">
                Čítať viac <ArrowRight size={16} />
              </Link>
            </div>
          </article>
        ))}
      </div>
    </section>
  </Layout>
);

export default NewsPage;
